// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3vtv1","calendarButtons":"ClockData_calendarButtons__Jpg_F"};